import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import CompanyManagement from './pages/company-management';
import UserManagement from './pages/user-management';
import Settings from './pages/settings';
import WorkOrderAnalytics from './pages/work-order-analytics';
import SmartFix from './pages/smart-fix';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        <Route path="/" element={<SmartFix />} />
        <Route path="/smart-fix" element={<SmartFix />} />
        <Route path="/company-management" element={<CompanyManagement />} />
        <Route path="/user-management" element={<UserManagement />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/work-order-analytics" element={<WorkOrderAnalytics />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
